import { EventSearch } from '../../types/index';

export const UPDATE_SEARCH_CRITERIA = 'UPDATE_SEARCH_CRITERIA';

export const updateSearchCriteria = (
    searchQuery: Omit<EventSearch, 'bbox'>,
    searchActionToLog = '',
) => ({
    type: UPDATE_SEARCH_CRITERIA,
    payload: {
        eventSearch: searchQuery,
        searchActionToLog,
    },
});
